import React from "react";

import { showModal } from "../../../../../lib/react-redux-modal-provider";
import StrategyNotificationSettingsSwitchers from "../components/StrategyNotificationSettingsSwitchers";

const showStrategyNotificationSettingsModal = ({
  translate,
  notificationTypes
}) => {
  showModal("NewModal", {
    title: translate("sid_dashboard_notification_settings_modal_title"),
    children: (
      <StrategyNotificationSettingsSwitchers
        notificationTypes={notificationTypes}
      />
    )
  });
};

export default showStrategyNotificationSettingsModal;
